import "../styles/statsbanner.css";

const StatsBanner = () => {

  return (

    <section className="stats-banner">

      <div className="stat-item">

        <h2>
          60s
        </h2>

        <h4>
          SHAKE READY IN
        </h4>

        <p>
          Under 60 seconds
        </p>

      </div>

      <div className="stat-item">

        <h2>
          6
        </h2>

        <h4>
          Flavour of 6 different protein trusted brands
        </h4>

        <p>
          ON, My Protein & more
        </p>

      </div>

      <div className="stat-item">

        <h2>
          100%
        </h2>

        <h4>
          MANAGED BY US
        </h4>

        <p>
          Fully automated system
        </p>

      </div>

      <div className="stat-item">

        <h2>
          €0
        </h2>

        <h4>
          STAFF COST
        </h4>

        <p>
          No extra staffing required
        </p>

      </div>

    </section>

  );

};

export default StatsBanner;